module.exports = __webpack_public_path__ + "img/h1.f719e2b3.svg";